/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".wrapper[_ngcontent-%COMP%]{padding-bottom:58px}@media (max-width:991px){.wrapper[_ngcontent-%COMP%]{margin:40px 0 62px}.image[_ngcontent-%COMP%]{margin-top:22px}}.image[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%}.align-right[_ngcontent-%COMP%]{text-align:right}"];
export { styles as styles };
